module.exports = __webpack_public_path__ + "static/img/banner111.6ac2cb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/icon/banner111.jpg
// module id = 62+1
// module chunks = 0